import React from "react";
import countryOffsets from "../../../../packages/common/vendor/flags/Phone-Country-Code-and-Flags.bundle/flag_indices.json";
import styles from "./flag.css";

interface Props {
  country: string;
  size?: number;
}

export class Flag extends React.Component<Props, {}> {
  render() {
    const size = this.props.size || 16;
    const offset = ((countryOffsets as any)[this.props.country] / 16) * size;
    return (
      <div
        className={styles.flag}
        style={{
          width: `${size}px`,
          minWidth: `${size}px`,
          height: `${size}px`,
          minHeight: `${size}px`,
          backgroundSize: `${size}px`,
          backgroundPosition: `0px -${offset}px`
        }}
      />
    );
  }
}
